/* DataGrid v7 */
if (!Array.prototype.at) {
  Array.prototype.at = function <T>(index: number): T | undefined {
    index = Math.trunc(index) || 0;

    if (index < 0) {
      index += this.length;
    }

    if (index < 0 || index >= this.length) {
      return undefined;
    }

    return this[index];
  };
}

/* DataGrid v8 */
if (!Object.hasOwn) {
  Object.defineProperty(Object, 'hasOwn', {
    value: function hasOwn(obj: any, key: PropertyKey): boolean {
      if (obj == null) {
        // Match spec behavior
        throw new TypeError('Object.hasOwn called on null or undefined');
      }
      const o = Object(obj);
      const k = typeof key === 'symbol' ? key : String(key);
      return Object.prototype.hasOwnProperty.call(o, k);
    },
    writable: true,
    configurable: true,
    enumerable: false,
  });
}
